import { useCallback } from "react";
import { store } from "src/redux/store";
import { selectIsAutosaveBlocked } from "src/redux/selectors/selectIsAutosaveBlocked";

import { requestAutosaveSchedule } from "./autosaveScheduler";

export const useTriggerAutoSave = () => {
  return useCallback(() => {
    if (selectIsAutosaveBlocked(store.getState())) return;
    requestAutosaveSchedule();
  }, []);
};
